/**
 * Metadati <head> dell'area OSS (/oss, /oss-login). Lo script inline di public/index.html li applica
 * prima del primo paint quando si apre direttamente l'area; questa funzione li applica (e li ripristina)
 * quando si entra navigando dentro la SPA. I valori devono coincidere con lo script inline (c'è un test).
 * Il viewport NON cambia: nell'area OSS lo zoom resta bloccato (decisione di prodotto).
 */
export const OSS_MANIFEST = "/oss-pwa/manifest.webmanifest";
export const OSS_THEME_LIGHT = "#F3F7F8";
export const OSS_THEME_DARK = "#121816";
export const OSS_APPLE_ICON = "/oss-pwa/icons/oss-apple-touch-180.png";
export const OSS_TITLE = "OSS";

export function isOssPath(p) {
  const s = String(p || "");
  return s === "/oss" || s.startsWith("/oss/") || s === "/oss-login";
}

function setAttr(sel, attr, val, saved) {
  const el = document.head.querySelector(sel);
  if (!el) return;
  saved.push([el, attr, el.getAttribute(attr)]);
  el.setAttribute(attr, val);
}

/** Applica i metadati OSS; restituisce una funzione che ripristina quelli originali. */
export function applyOssHead() {
  if (typeof document === "undefined") return () => {};
  if (document.documentElement.getAttribute("data-app") === "oss" && document.head.querySelector('meta[data-oss="1"]')) {
    return () => {};
  }
  const saved = [];
  setAttr('link[rel="manifest"]', "href", OSS_MANIFEST, saved);
  setAttr('meta[name="theme-color"]', "content", OSS_THEME_LIGHT, saved);
  setAttr('meta[name="theme-color"]', "media", "(prefers-color-scheme: light)", saved);
  setAttr('meta[name="apple-mobile-web-app-title"]', "content", OSS_TITLE, saved);
  setAttr('meta[name="application-name"]', "content", OSS_TITLE, saved);
  setAttr('link[rel="apple-touch-icon"]', "href", OSS_APPLE_ICON, saved);
  const dark = document.createElement("meta");
  dark.name = "theme-color";
  dark.content = OSS_THEME_DARK;
  dark.setAttribute("media", "(prefers-color-scheme: dark)");
  dark.setAttribute("data-oss", "spa");
  document.head.appendChild(dark);
  document.documentElement.setAttribute("data-app", "oss");
  return () => {
    for (let i = saved.length - 1; i >= 0; i -= 1) {
      const [el, attr, val] = saved[i];
      if (val === null) el.removeAttribute(attr);
      else el.setAttribute(attr, val);
    }
    dark.remove();
    document.documentElement.removeAttribute("data-app");
  };
}
